/**
 * Created by hao.cheng on 2017/4/13.
 */
import React, { Component } from 'react';
import { Menu, Icon, Layout, Badge, Popover,Dropdown,Col,Input,Modal,notification,Row  } from 'antd';
import { connect } from 'react-redux';
import { withRouter,Link } from 'react-router-dom';
import fw from '@/style/imgs/all/fw.png';
import logo from '@/style/imgs/all/logo.png';
import phone from '@/style/imgs/all/phone.png';
import phone1 from '@/style/imgs/all/phone1.png';
import menuLogo from '@/style/imgs/all/menuLogo.png';
import al from '@/style/imgs/all/al.png';
import lx from '@/style/imgs/all/lx.png';
import jr from '@/style/imgs/all/jr.png';
import zx from '@/style/imgs/all/zx.png';
import jy from '@/style/imgs/all/jy.png';
import ydjyewm from '@/style/imgs/all/yidian.png';
import SiderCustom from "./SiderCustom";
const { Header } = Layout;
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class HeaderCustom extends Component {
    state = {
        current:"",
        changeMenuWidth:false
    };
    componentDidMount() {
        const {history} = this.props;
        let index = history.location.pathname.lastIndexOf("\/");
        let key= history.location.pathname.substring(index + 1, history.location.pathname.length);
        if(key=="lxwm" ||  key=="yjjy"){
            this.setState({
                changeMenuWidth:true
            })
        }else{
            this.setState({
                changeMenuWidth:false
            })
        }
        this.setState({
            openKey: (key=="ptrk" || key=="zpxx")?"jrwm":key,
            selectedKey:key,
            current:`${key}`,
        });
    };
    componentWillReceiveProps(nextProps) {
        this.onCollapse(nextProps.collapsed);
        this.setMenuOpen(nextProps)
    }
    turnlogin =()=>{
        const { history } = this.props;
        window.open("http://hd.feima666.com");
    }
    setMenuOpen = props => {
        const { pathname } = props.location;
        let index = pathname.lastIndexOf("\/");
        let key= pathname.substring(index + 1,pathname.length);
        if(key=="lxwm" ||  key=="yjjy"){
            this.setState({
                changeMenuWidth:true
            })
        }else{
            this.setState({
                changeMenuWidth:false
            })
        }
        this.setState({
            openKey: (key=="ptrk" || key=="zpxx")?"jrwm":key,
            selectedKey:key,
            current:`${key}`,
        });
    };
    onCollapse = (collapsed) => {
        this.setState({
            collapsed,
            firstHide: collapsed,
            mode: collapsed ? 'vertical' : 'inline',
        });
    };
    menuClick = e => {
        this.setState({
            selectedKey: e.key
        });
        const {history} = this.props;
        if(e.key!="ptrk"){
            history.push("/feima/"+e.key)
        }
    };
    openMenu = v => {
        this.setState({
            openKey: v[v.length - 1],
            firstHide: false,
        })
    };
    appOver =()=>{
        this.setState({
            appOver:true
        })
    }
    appOut =()=>{
        this.setState({
            appOver:false
        })
    }
    render() {
        return (
            <div style={{width:1912}}>
                <Col style={{height:44,background:"#333",width:"100%",overflow:"hidden"}}>
                    <Col style={{float:"left",marginLeft:350}}>
                        <img style={{marginTop:6}} src={logo} alt=""/>
                        <img style={{marginTop:16,marginLeft:30}} src={fw} alt=""/>
                    </Col>
                    <Col style={{float:"right",marginRight:373,fontSize:16,color:"#fff",lineHeight:"52px"}}>
                        24小时救援热线：400-070-9995 <span style={{marginLeft:20}}>开放平台</span>
                    </Col>
                </Col>
                <Col style={{backgroundColor:"#fff",paddingLeft:350,paddingRight:100,height:50}} >
                    <Row className="headMenu">
                        <Menu
                            onClick={this.handleClick}
                            selectedKeys={[this.state.current]}
                            mode="horizontal"
                            style={{height:50}}
                        >
                            <Menu.Item style={{padding:0,marginRight:30}} key="login">
                               <Link style={{fontSize:16,color:"#212121"}} to="/"  rel="noopener noreferrer">首页</Link>
                            </Menu.Item>
                            <Menu.Item style={{padding:0,marginRight:30}} key="gywm">
                                <Link style={{fontSize:16,color:"#212121"}} to="/feima/gywm"  rel="noopener noreferrer">关于我们</Link>
                            </Menu.Item>
                            <Menu.Item style={{padding:0,marginRight:30}} key="cgal">
                                <Link style={{fontSize:16,color:"#212121"}} to="/feima/cgal"  rel="noopener noreferrer">成功案例</Link>
                            </Menu.Item>
                            <Menu.Item style={{padding:0,marginRight:30}} key="xwzx">
                                <Link style={{fontSize:16,color:"#212121"}} to="/feima/xwzx"  rel="noopener noreferrer">新闻中心</Link>
                            </Menu.Item>
                            <SubMenu className="jrwmMenu" style={{fontSize:16,color:"#212121",padding:0,marginRight:30}} title={<span className="submenu-title-wrapper">加入我们</span>}>
                                <MenuItemGroup>
                                    <Menu.Item key="ptrk">
                                        <a target="_blank" href="https://hd.feima666.com"  rel="noopener noreferrer">平台入口</a>
                                    </Menu.Item>
                                    <Menu.Item key="zpxx">
                                        <Link to="/feima/zpxx"  rel="noopener noreferrer">招聘信息</Link>
                                    </Menu.Item>
                                </MenuItemGroup>
                            </SubMenu>
                            <Menu.Item style={{padding:0,marginRight:30}} key="lxwm">
                                <Link style={{fontSize:16,color:"#212121"}} to="/feima/lxwm"  rel="noopener noreferrer">联系我们</Link>
                            </Menu.Item>
                            <Menu.Item  style={{padding:0}} key="yjjy">
                                <Link style={{fontSize:16,color:"#212121"}} to="/feima/yjjy"  rel="noopener noreferrer">一键救援</Link>
                            </Menu.Item>
                            <Col onMouseOver={this.appOver} onMouseOut={this.appOut} style={{float:"right",cursor:"pointer",lineHeight:"20px",fontSize:16,marginRight:273,color:this.state.appOver?"#d2a475":"#212121",marginTop:-12}}>
                                <Col>
                                    <Popover placement="top" content={<div style={{height:200,width:200}}><img src={ydjyewm} alt=""/></div>} title="扫描二维码下载">
                                        <img style={{marginRight:10,color:"#d2a475"}} src={this.state.appOver?phone1:phone} alt=""/>下载一点APP
                                    </Popover>
                                </Col>
                            </Col>
                        </Menu>
                    </Row>

                </Col>
                <div  style={{position:"absolute",height:this.state.changeMenuWidth?850:650,left:362,width:200,top:142,border:"1px solid #ccc"}}>
                    <Col>
                        <img onClick={this.turnlogin} style={{width:198,cursor:"pointer"}} src={menuLogo} alt=""/>
                    </Col>
                    <Menu
                        style={{height:this.state.changeMenuWidth?789:589}}
                        defaultSelectedKeys={['1']}
                        defaultOpenKeys={['sub1']}
                        onClick={this.menuClick}
                        mode="inline"
                        selectedKeys={[this.state.selectedKey]}
                        openKeys={this.state.firstHide ? null : [this.state.openKey]}
                        onOpenChange={this.openMenu}
                    >
                        <Menu.Item key="cgal" className="noTop">
                            <img style={{marginRight:10,marginTop:-1}} src={al} alt=""/>
                            成功案例
                        </Menu.Item>
                        <Menu.Item key="xwzx" className="noTop">
                            <img style={{marginRight:10,marginTop:-1}} src={zx} alt=""/>
                                新闻中心
                        </Menu.Item>
                        <SubMenu className="noTop" key="jrwm" title={<span><img style={{marginRight:10,marginTop:-1}} src={jr} alt=""/><span>加入我们</span></span>}>
                            <Menu.Item key="ptrk"><a target="_blank" href="http://hd.feima666.com"  rel="noopener noreferrer">平台入口</a></Menu.Item>
                            <Menu.Item key="zpxx"><Link to={"zpxx"}>招聘信息</Link></Menu.Item>
                        </SubMenu>
                        <Menu.Item key="lxwm" className="noTop">
                            <img style={{marginRight:10,marginTop:-1}} src={lx} alt=""/>
                            联系我们

                        </Menu.Item>
                        <Menu.Item key="yjjy" className="noTop">
                            <img style={{marginRight:10,marginTop:-1}} src={jy} alt=""/>
                           一键救援
                        </Menu.Item>
                    </Menu>
                </div>

            </div>
        )
    }
}


export default withRouter(connect()(HeaderCustom));



// WEBPACK FOOTER //
// ./src/components/HeaderCustom.jsx